import { api, unwrap } from "./httpClient";
import type { CreateTransactionPayload, Transaction } from "../types/api";

export const listTransactions = (userId: number) =>
  unwrap<Transaction[]>(api({ method: "GET", url: `/transactions/${userId}` }));

export const createTransaction = (payload: CreateTransactionPayload) =>
  unwrap<Transaction>(
    api({ method: "POST", url: "/transactions", data: payload })
  );
